export function getCount(value) {
  return `${value} external mapping${value === 1 ? '' : 's'}`
}
